module.exports = __webpack_public_path__ + "static/about-fe8b3c3101f2995d853f5f2d48f5efb9.png";